import { UserRole } from '@academia-apolo/shared-types';
import { ROUTES } from '@/lib/constants';
/** Infer the target section from a (legacy, role-agnostic) notification link. */
function sectionFromLink(link) {
    const l = link.toLowerCase();
    if (/pago|payment/.test(l))
        return 'payments';
    if (/grabacion|recording/.test(l))
        return 'recordings';
    if (/material/.test(l))
        return 'materials';
    if (/convocatoria|announcement/.test(l))
        return 'announcements';
    if (/blog/.test(l))
        return 'blog';
    if (/horario|schedule/.test(l))
        return 'schedules';
    if (/solicitud|request/.test(l))
        return 'requests';
    if (/asistencia|attendance/.test(l))
        return 'attendance';
    if (/prospect|posible/.test(l))
        return 'prospects';
    return null;
}
/** The valid in-app route for a section, per role (null = no destination). */
function routeFor(section, role) {
    const D = role === UserRole.DIRECTOR;
    const P = role === UserRole.PROFESSOR;
    const S = role === UserRole.STUDENT;
    switch (section) {
        case 'payments':
            return S ? ROUTES.STUDENT_PAYMENTS : D ? ROUTES.DIRECTOR_PAYMENTS : P ? ROUTES.PROFESSOR_PAYMENTS : null;
        case 'materials':
            return S ? ROUTES.STUDENT_MATERIALS : D ? ROUTES.DIRECTOR_MATERIALS : P ? ROUTES.PROFESSOR_MATERIALS : null;
        case 'recordings':
            return S ? ROUTES.STUDENT_RECORDINGS : D ? ROUTES.DIRECTOR_RECORDINGS : null;
        case 'announcements':
            return D ? ROUTES.DIRECTOR_ANNOUNCEMENTS : null;
        case 'blog':
            return D ? ROUTES.DIRECTOR_BLOG : P ? ROUTES.PROFESSOR_BLOG : null;
        case 'schedules':
            return S ? ROUTES.STUDENT_SCHEDULE : D ? ROUTES.DIRECTOR_SCHEDULES : P ? ROUTES.PROFESSOR_CLASSES : null;
        case 'requests':
            return S ? ROUTES.STUDENT_REQUESTS : D ? ROUTES.DIRECTOR_REQUESTS : null;
        case 'attendance':
            // Director-como-profesor: sus recordatorios de pasar lista van a "Mis clases".
            return S ? ROUTES.STUDENT_ATTENDANCE : D || P ? ROUTES.PROFESSOR_CLASSES : null;
        case 'prospects':
            return D ? ROUTES.DIRECTOR_PROSPECTS : null;
    }
}
/**
 * Resolves a notification's stored link to a route that actually exists for the
 * current user's role. Stored links are legacy/role-agnostic (e.g. `/pagos`,
 * `/solicitudes/:id`, `/director/prospects/:id`) and match no route in the panel
 * router, so clicking them produced a "Not found". We re-derive the destination
 * from the link's intent + the role; returns null when there's no valid target
 * (the item is then shown as non-clickable instead of navigating to a 404).
 */
export function resolveNotificationHref(link, role) {
    if (!link || !role)
        return null;
    const section = sectionFromLink(link);
    if (!section)
        return null;
    const base = routeFor(section, role);
    if (!base)
        return null;
    // Recordatorio de pasar lista: el link lleva la clase (/asistencia/clase/<uuid>).
    // Para el staff, abrir "Mis clases" con el modal de esa clase via ?classId=.
    if (section === 'attendance' && role !== UserRole.STUDENT) {
        const match = /\/asistencia\/clase\/([0-9a-f-]{36})/i.exec(link);
        if (match)
            return `${base}?classId=${match[1]}`;
    }
    return base;
}
//# sourceMappingURL=notification-route.js.map